'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

exports.Dock = Dock;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDimensions = require('react-dimensions');

var _reactDimensions2 = _interopRequireDefault(_reactDimensions);

var _deck = require('./deck');

var _deck2 = _interopRequireDefault(_deck);

var _docker_reducer = require('./docker_reducer');

var _docker_reducer2 = _interopRequireDefault(_docker_reducer);

var _constants = require('../../common/constants');

var Constants = _interopRequireWildcard(_constants);

var _store = require('../../common/store');

var _store2 = _interopRequireDefault(_store);

var _helpers = require('../../common/helpers');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
// import { Notify } from '../../components/Notifications/Notifications'
// import { chatLeaveRequest } from '../../redux/modules/chats'


var Docker = function (_Component) {
    _inherits(Docker, _Component);

    function Docker(props) {
        _classCallCheck(this, Docker);

        var _this = _possibleConstructorReturn(this, (Docker.__proto__ || Object.getPrototypeOf(Docker)).call(this, props));

        _this.addDeckRequest = function (meeting_details, participants) {
            _this.props.dispatch((0, _docker_reducer.addDeckRequest)(meeting_details, participants));
        };

        _this.removeDeck = function (meeting_id) {
            _this.props.dispatch((0, _docker_reducer.removeDeck)(meeting_id));
        };

        _this.clearDocker = function () {
            _this.props.dispatch((0, _docker_reducer.clearDock)());
        };

        _this.updateVisitorNetworkStatus = function (user_details) {
            _this.props.dispatch((0, _docker_reducer.updateVisitorNetworkStatus)(user_details));
        };

        _this.verifyMeetingStatus = function () {
            var decks = _this.props.docker.decks;
            var self = _this;
            decks.map(function (deck) {

                new Promise(function (resolve, reject) {
                    var meetingInfoUrl = window.sfChat.baseApiUrl + "/v1/meeting/" + deck.meeting_id + "/info";
                    var headers = (0, _helpers.getAuthHeader)();
                    fetch(meetingInfoUrl, {
                        method: 'GET',
                        headers: headers
                    }).then(function (response) {
                        return response.json();
                    }).then(function (res) {
                        return resolve(res);
                    }).catch(function (e) {
                        return reject(e);
                    });
                }).then(function (response) {
                    if (response.status === "success") {
                        if (response.data.status !== "inprogress") {
                            self.removeDeck(response.data.id);
                            var notificationDetails = {
                                title: "New Meeting",
                                message: "Meeting " + response.data.id + " is no longer open to you. Has been removed from open chats.",
                                level: "info",
                                autoDismiss: 10,
                                actionLabel: "OK"
                                // Notify().showNotification(notificationDetails)
                            };console.log("Meeting " + response.data.id + " is no longer open to you. Has been removed from open chats.");
                        }
                    } else {
                        self.removeDeck(response.data.id);
                        var _notificationDetails = {
                            title: "New Meeting",
                            message: "Failed to verify status for meeting " + response.data.id + ". Has been removed from open chats.",
                            level: "info",
                            autoDismiss: 10,
                            actionLabel: "OK"
                            // Notify().showNotification(notificationDetails)
                        };console.log("Failed to verify status for meeting " + response.data.id + ". Has been removed from open chats.");
                    }
                });
                return null;
            });
        };

        _this.switchDecks = function (chatProps) {
            _this.props.dispatch((0, _docker_reducer.switchDecks)(chatProps));
        };

        _this._onMenuItemClick = function () {
            _this.setState({
                stackedDeckDisplayStyle: _this.state.stackedDeckDisplayStyle === 'none' ? 'block' : 'none'
            });
        };

        _this.state = {
            decks: [],
            stackedDeckDisplayStyle: 'none',
            visible_decks: [],
            stacked_decks: []
        };

        _this.dockerWidth = null;
        _this.dockerRef = null;
        _this.visibleDeckOffsetRight = [];
        return _this;
    }

    _createClass(Docker, [{
        key: 'componentWillMount',
        value: function componentWillMount() {
            var self = this;
            if (this.props.docker.visible_decks.length > 0) {
                this.props.docker.visible_decks.map(function (deck, index) {
                    if (self.visibleDeckOffsetRight.length > 0) {
                        self.visibleDeckOffsetRight.push(self.visibleDeckOffsetRight[self.visibleDeckOffsetRight.length - 1] + 310);
                    } else {
                        self.visibleDeckOffsetRight.push(55);
                    }
                    return null;
                });
            }

            this.verifyMeetingStatus();
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            if (window) {
                if (!window.jmdashboard) {
                    window.jmdashboard = [];
                }
                window.jmdashboard["dock"] = this;
            } else {
                console.log("Error: window object not found, app not running in browser environment");
            }

            if (this.dockerWidth !== this.dockerRef.offsetWidth) {
                this.dockerWidth = this.dockerRef.offsetWidth;
            }
        }
    }, {
        key: 'componentWillReceiveProps',
        value: function componentWillReceiveProps(nextProps) {
            var self = this;
            if (this.props.docker.visible_decks.length !== nextProps.docker.visible_decks.length) {
                if (nextProps.docker.visible_decks.length > 0) {
                    nextProps.docker.visible_decks.map(function (deck, index) {
                        if (self.visibleDeckOffsetRight.length > 0) {
                            self.visibleDeckOffsetRight.push(self.visibleDeckOffsetRight[self.visibleDeckOffsetRight.length - 1] + 310);
                        } else {
                            self.visibleDeckOffsetRight.push(55);
                        }
                        return null;
                    });
                }
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            console.log('Docker.. .Component will unmount....');
            this.props.dispatch((0, _docker_reducer.clearDock)());
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate() {
            if (this.dockerWidth !== this.dockerRef.offsetWidth) {
                this.dockerWidth = this.dockerRef.offsetWidth;
            }

            var decks_can_be_shown = Math.floor((this.props.containerWidth - 50) / 310);
            if (decks_can_be_shown < 4) {
                if (decks_can_be_shown !== this.props.docker.max_visible_decks) {
                    this.props.dispatch((0, _docker_reducer.rearrangeDecks)(decks_can_be_shown));
                }
            } else {
                this.props.dispatch((0, _docker_reducer.rearrangeDecks)(3));
            }
        }

        // addDeck(chatProps) {
        //     this.props.dispatch(addDeckRequest(chatProps.meeting_id, chatProps.participantsData.participant_list))

        // }

        // removeDeck = (meeting_id) => {
        //     this.props.dispatch(removeDeck(meeting_id))
        //     this.props.dispatch(chatLeaveRequest(meeting_id))
        // }

    }, {
        key: 'render',
        value: function render() {
            var _this2 = this;

            var self = this;
            var visibleDecks = null,
                stackedDecks = null;

            visibleDecks = this.props.docker.visible_decks.map(function (deck, index) {
                return _react2.default.createElement(
                    'div',
                    { key: Date.now() + Math.random(), style: { zIndex: '999', position: 'fixed', bottom: '0', float: 'right', right: self.visibleDeckOffsetRight[index] + "px" } },
                    _react2.default.createElement(_deck2.default, { deck: deck, type: 'visible', dispatch: self.props.dispatch, removeDeck: self.removeDeck }),
                    '\xA0\xA0'
                );
            });
            stackedDecks = this.props.docker.stacked_decks.map(function (deck) {
                return _react2.default.createElement(
                    'div',
                    { key: Date.now() + Math.random() },
                    _react2.default.createElement(_deck2.default, { deck: deck, type: 'stacked', switchDecks: self.switchDecks, removeDeck: self.removeDeck }),
                    '\xA0'
                );
            });

            var menuiconDisplayStyle = "none";

            if (stackedDecks.length) menuiconDisplayStyle = "block";

            return _react2.default.createElement(
                'div',
                { id: 'docker', ref: function ref(_ref) {
                        return _this2.dockerRef = _ref;
                    } },
                visibleDecks,
                _react2.default.createElement(
                    'div',
                    { style: { padding: '2vh', bottom: '0', position: 'fixed', float: 'right', right: '0', zIndex: "99999" } },
                    _react2.default.createElement(
                        'div',
                        { style: { display: this.state.stackedDeckDisplayStyle, maxHeight: "200px", overflowX: "auto" } },
                        stackedDecks
                    ),
                    _react2.default.createElement(
                        'button',
                        { className: 'btn btn-default dropdown-toggle', type: 'button', id: 'menuicon', onClick: function onClick() {
                                _this2._onMenuItemClick();
                            }, 'data-toggle': 'dropdown', 'aria-haspopup': 'true', 'aria-expanded': 'false',
                            style: { bottom: '0', right: '5px', float: 'right', display: menuiconDisplayStyle } },
                        _react2.default.createElement(
                            'span',
                            null,
                            _react2.default.createElement('i', { className: 'fa fa-bars' })
                        )
                    )
                )
            );
        }
    }]);

    return Docker;
}(_react.Component);

function Dock() {
    return window.jmdashboard["dock"];
}

Docker.Store = Docker.Store ? Docker.Store : new _store2.default(Constants.NS_DOCKER, { dockerState: _docker_reducer2.default });

var mapStateToProps = function mapStateToProps(state, ownProps) {
    return {
        docker: state.dockerState
    };
};

var options = {
    containerStyle: {
        width: "100%",
        height: "100%"
    }
};

exports.default = (0, _store.connectWithStore)(Docker.Store.getStore(), (0, _reactDimensions2.default)(options)(Docker), mapStateToProps);


// WEBPACK FOOTER //
// ../chat/lib/components/dock/docker.js